$(function() {
    jsSocials.shares['facebook'] = {
        label: "Share",
        logo: "fab fa-facebook-f",
        shareUrl: "https://facebook.com/sharer/sharer.php?u={url}",
        countUrl: "https://graph.facebook.com/?id={url}",
        getCount: function (data) {
            return data.share && data.share.share_count || 0;
        }
    }
    jsSocials.shares['twitter'] = {
        label: "Tweet",
        logo: "fab fa-twitter",
        shareUrl: "https://twitter.com/share?url={url}&text={text}&via={via}&hashtags={hashtags}",
        countUrl: ""
    }
    jsSocials.shares['email'] = {
        label: "Email",
        logo: "fas fa-envelope",
        shareUrl: "mailto:{to}?subject={text}&body={url}",
        countUrl: "",
        shareIn: "self"
    }
//        jsSocials.shareStrategies['emailStrategy'] = function(args) {
//            console.log(args);
//            console.log(this);
//            return $("<div>").click(function() {
//            });
//        }
    $(function () {
        $(".share-icons").each(function (i, el) {
            var text = $(el).attr('data-text') || null;
            var shareUrl = $(el).attr('data-url') || window.location.href;
            const embed = $(el).attr("data-embed") || false;
            const activeShares = [
                "facebook",
                "twitter",
                "email",

            ];
            if(embed) {
                activeShares.push({
                    renderer: function(a) {
                        const embed = $(el).attr("data-embed");
                        if(typeof embed !== typeof undefined && embed) {
                            var $result = $("<div>",{
                                class: 'jssocials-share jssocials-share-email'
                            });
                            var $button = $("<a>",{
                                'href':'#',
                                'class':'jssocials-share-link',
                                'data-toggle':'modal',
                                'data-target': '#embed-modal'
                            }).html('<i class="fas fa-link jssocials-share-logo" ></i>');

                            return $result.append($button);
                        }
                    }
                })
            }

            $(el).jsSocials({
                shares: activeShares,
                showLabel: false,
                showCount: false,
                text: text,
                url: shareUrl,
                shareIn: "popup",
            });
        });
    });

    $('.view-gallery').fancybox({});

    $('.vi_image_gallery_wrap .gallery_thumbnails').slick({
        prevArrow: '<button type="button" class="slick-prev"><i class="fa fa-angle-left"></i></button>',
        nextArrow: '<button type="button" class="slick-next"><i class="fa fa-angle-right"></i></button>',
        infinite: true,
        centerMode: true,
        vertical: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        // adaptiveHeight: false,
        height:350,
        focusOnSelect: true,
        asNavFor: '.vi_image_gallery_wrap .gallery_scene',
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    vertical:false,
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
        ]
    });

    $('.vi_image_gallery_wrap .gallery_scene').slick({
        dots: false,
        arrows: false,
        infinite: true,
        // speed: 1200,
        slidesToShow: 1,
        // adaptiveHeight: true,
        centerMode: false,
        fade: false,
        asNavFor: '.vi_image_gallery_wrap .gallery_thumbnails',
        prevArrow: '<button type="button" class="slick-prev"><i class="fa fa-angle-left"></i></button>',
        nextArrow: '<button type="button" class="slick-next"><i class="fa fa-angle-right"></i></button>',
    });

	$("body").on("click",".ease-scroll", function(e) {
	    e.preventDefault();
	    var target = $(this).attr("href");
	    var element = $(target);

	    if(element.length) {
            $('html, body').animate({
                scrollTop: element.offset().top - 50
            }, 1000);
        }
    });

	$("body").on("click",".add-to-favorites", function(e) {
		e.preventDefault();
		var that = $(this);
		var property_id = that.attr("data-property_id");

		if(property_id.length) {
			$.ajax({
				url: add_to_favorites_url,
				data: {
                    _token: $('meta[name="csrf-token"]').attr('content'),
                    property_id: property_id
				},
				type: 'post',
				dataType:'json',
				success: function(r) {
					if(r.status == "ok") {
                        $('.add-to-favorites[data-property_id="'+property_id+'"]').removeClass("add-to-favorites").addClass("remove-from-favorites");

                        if(typeof r.count !== typeof undefined) {
                            $(".favorites-counter").removeClass("active").removeClass("inactive").addClass( (parseInt(r.count) > 0 ? 'active' : 'inactive') ).html(r.count);
                        }
					}
				}
			});
		}
	});

    $("body").on("click",".remove-from-favorites", function(e) {
        e.preventDefault();
        var that = $(this);
        var property_id = that.attr("data-property_id");

        if(property_id.length) {
            $.ajax({
                url: remove_from_favorites_url,
                data: {
                    _token: $('meta[name="csrf-token"]').attr('content'),
                    property_id: property_id
                },
                type: 'post',
                dataType:'json',
                success: function(r) {
                    if(r.status == "ok") {
                        $('.remove-from-favorites[data-property_id="'+property_id+'"]').removeClass("remove-from-favorites").addClass("add-to-favorites");
                        if(typeof r.count !== typeof undefined) {
                            $(".favorites-counter").removeClass("active").removeClass("inactive").addClass( (parseInt(r.count) > 0 ? 'active' : 'inactive') ).html(r.count);
                        }
                    }
                }
            });
        }
    });

    $(".toggle_menu").click(function(){
        $(".menu_holder").slideToggle();
    });

    if($(".custom-tabs").length) {
        $(".custom-tabs").find(".tab-navi > a:first-child").addClass("active first");
        $(".custom-tabs").addClass("loaded")
    }

    $(".custom_tab").click(function(){
        var rel = "#" + $(this).attr("rel");
        $(".custom_tab").removeClass("active");
        $(this).addClass("active");
        $(".tab_content").hide();
        $(rel).find(".slick-slider").slick('setPosition');
        $(rel).fadeIn(800, function() {
            $(rel).find(".slick-slider").slick('setPosition');
            $(rel).find(".slick-slider").resize();
        });
        $(rel).find(".slick-slider").resize();
    });

    const activeTab = $(".custom_tab:first-child");
    if(activeTab.length) {
        activeTab.addClass("active");
        var rel = "#" + activeTab.attr("rel");
        $(rel).show();
        $(rel).find(".slick-slider").slick('setPosition');
        $(rel).find(".slick-slider").resize();
    }

    $("#btn_advanced_search").click(function(){
        $(".search_rows").slideToggle();
    });


    function setTitlegBoxMinHeight() {
        var box = $(".post_box h4");
        $(box).css({
            minHeight: "auto"
        });
        var heights = $(box).map(function () {
                return $(this).innerHeight();
            }).get(),
            maxHeight = "0";
        maxHeight = Math.max.apply(null, heights);

        $(box).css({
            minHeight: maxHeight
        });
       
    }

    setTitlegBoxMinHeight();

    $(window).resize(function() {
        setTitlegBoxMinHeight();
    });

    function setPricingBoxMinHeight() {
        var box = $(".pricing_section .box .box_content");
        if(box) {
            $(box).css({
                minHeight: "auto"
            });
            var heights = $(box).map(function () {
                    return $(this).innerHeight();
                }).get(),
                maxHeight = "0";
            maxHeight = Math.max.apply(null, heights);

            $(box).css({
                minHeight: maxHeight
            });
        }
    }

    function setListMinHeight() {
        if (window.matchMedia("(min-width: 768px)").matches) {
            let ul = $(".pricing_section .box .box_content ul");
            if(ul) {
                $(ul).each(function() {
                    $($(this).children()).each(function(i) {
                        $(this).addClass("index-"+i);
                        let heights = $(".index-"+i).map(function () {
                            return $(this).innerHeight();
                        }).get(),
                        maxHeight = "0";
                        maxHeight = Math.max.apply(null, heights);
                        $(".minH.index-"+i).css({minHeight: maxHeight });
                    });
                });
            }
        } else {
            $(".pricing_section .box .box_content ul li").css({minHeight: 0 });
        }
    }
    
    setListMinHeight();
    // setPricingBoxMinHeight();

    $(window).resize(function() {
        setListMinHeight();
        // setPricingBoxMinHeight();
    });

    $('.pricing-tab').click(function() {
        $(".pricing_section .box .box_content ul li").css({minHeight: 0 });
        setListMinHeight();
    })


    function setImgBoxMinHeight() {
        var box = $(".post_box .img_holder");
        if(box) {
            // $(box).css({
            //     minHeight: "auto"
            // });
            // var heights = $(box).map(function () {
            //         return $(this).innerHeight();
            //     }).get(),
            //     maxHeight = "0";
            // maxHeight = Math.max.apply(null, heights);
            //
            // $(box).css({
            //     maxHeight: maxHeight
            // });
        }
    }

    $(window).on("load", function(){
        setImgBoxMinHeight();
    });
   

    $(window).on("resize", function() {
        setImgBoxMinHeight();
    });

});

const scrollbar = document.querySelector('.smooth-scrollbar');
if(scrollbar) {
    Scrollbar.init(scrollbar);
}


/*
 * Bootstrap Cookie Alert by Wruczek
 * https://github.com/Wruczek/Bootstrap-Cookie-Alert
 * Released under MIT license
 */
(function () {
    "use strict";

    var cookieAlert = document.querySelector(".cookiealert");
    var acceptCookies = document.querySelector(".acceptcookies");

    if (!cookieAlert) {
       return;
    }

    cookieAlert.offsetHeight; // Force browser to trigger reflow (https://stackoverflow.com/a/39451131)

    // Show the alert if we cant find the "acceptCookies" cookie
    if (!getCookie("acceptCookies")) {
        cookieAlert.classList.add("show");
    }

    // When clicking on the agree button, create a 1 year
    // cookie to remember user's choice and close the banner
    acceptCookies.addEventListener("click", function () {
        setCookie("acceptCookies", true, 365);
        cookieAlert.classList.remove("show");
    });

    // Cookie functions from w3schools
    function setCookie(cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        var expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    function getCookie(cname) {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }
})();

$.validator.addMethod(
    "validEmail",
    function (value, element) {
        if (value == "") return true;
        var temp1;
        temp1 = true;
        var ind = value.indexOf("@");
        var str2 = value.substr(ind + 1);
        var str3 = str2.substr(0, str2.indexOf("."));
        if (
            str3.lastIndexOf("-") == str3.length - 1 ||
            str3.indexOf("-") != str3.lastIndexOf("-")
        )
            return false;
        var str1 = value.substr(0, ind);
        if (
            str1.lastIndexOf("_") == str1.length - 1 ||
            str1.lastIndexOf(".") == str1.length - 1 ||
            str1.lastIndexOf("-") == str1.length - 1
        )
            return false;
        str = /(?!.*\.{2})^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i;
        temp1 = str.test(value);
        return temp1;
    },
);

jQuery.extend(jQuery.validator.messages, {
    email: "E-mail invalid",
});

// SUBMIT CONTACT
$("#submit-contact").on("click tap touch", function (e) {
    $("#contact-form").validate({
        rules: {
            nume_prenume: {
                required: true,
                normalizer: function (value) {
                    return $.trim(value);
                }
            },
            email: {
                required: true,
                validEmail: true
            }
        },
        messages: {
            nume_prenume: "*Câmp obligatoriu",
            email: {
                required: "*Câmp obligatoriu",
                validEmail: "E-mail invalid"
            },
        },
    });
});

/* VideoPopUp
 * Author: Sławomir Netteria.NET https://netteria.net
 */
(function ($) {

    $.fn.VideoPopUp = function (options) {
        
        var defaults = {
            backgroundColor: "#000000",
            opener: "video",
            maxweight: "640",
            pausevideo: false,
            idvideo: ""
        };
        
        var patter = this.attr('id');

        var settings = $.extend({}, defaults, options);

        var video = document.getElementById(settings.idvideo);
        function stopVideo() {
            var tag = $('#' + patter + '').get(0).tagName;
            if (tag == 'video') {
                video.pause();
                video.currentTime = 0;
            }
        }
        
        $('#' + patter + '').css("display", "none");
        $('#' + patter + '').append('<div class="opct"></div>');
        $('.opct').css("background", settings.backgroundColor);
        $('#' + patter + '').css("z-index", "100001");
        $('#' + patter + '').css("position", "fixed")
        $('#' + patter + '').css("top", "0");
        $('#' + patter + '').css("bottom", "0");
        $('#' + patter + '').css("right", "0");
        $('#' + patter + '').css("left", "0");
        $('#' + patter + '').css("padding", "auto");
        $('#' + patter + '').css("text-align", "center");
        $('#' + patter + '').css("background", "none");
        $('#' + patter + '').css("vertical-align", "vertical-align");
        $(".videCont").css("z-index", "100002");
        $('#' + patter + '').append('<div class="closer_videopopup">&otimes;</div>');
        $("#" + settings.opener + "").on('click', function () {
            $('#' + patter + "").fadeIn("fast");
            $('#'+settings.idvideo+'').trigger('play');
            $('#'+settings.idvideo+'').trigger('play');
        });
        $(".closer_videopopup").on('click', function () {
            $('#'+settings.idvideo+'').trigger('pause');
            video.currentTime = 0;

            // if(settings.pausevideo==true){
            //         $('#'+settings.idvideo+'').trigger('pause');
            //     }else{
            //         stopVideo();
            //     }
            $('#' + patter + "").fadeOut("fast");
        });
        return this.css({

        });
    };

}(jQuery));


// WEBPACK FOOTER //
// ./resources/assets/frontend/js/custom.js